<template>
  <div class="header">
    <h1>用戶填答結果 - 企業列表</h1>
  </div>
  <div class="filter">
    <div class="d-flex">
      <div class="position-relative d-flex align-items-center col-4">
        <CFormInput
          class="rounded-pill pe-5"
          type="text"
          placeholder="請輸入企業名稱或相關資訊"
          v-model="filterValue"
        />
        <!-- <img
          class="position-absolute search"
          src="@/assets/icons/search.svg"
          alt=""
        /> -->
      </div>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto list-title">
    <CCol xs="2" class="text-center">公司名稱</CCol>
    <CCol xs="1" class="text-center text-nowrap">問卷創建日期</CCol>
    <CCol xs="3" class="text-center">問卷名稱</CCol>
    <CCol xs="1" class="text-center text-nowrap">最後填答日期</CCol>
    <CCol xs="2" class="text-center text-nowrap ps-0">問卷回覆狀態</CCol>
    <CCol xs="1" class="text-center text-nowrap">問卷結果</CCol>
    <CCol xs="1" class="text-center">下載問卷結果</CCol>
  </CRow>
  <CRow
    v-for="item in filteredEnterpriseList"
    :key="item.name"
    class="mb-4 py-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <CCol xs="2" class="text-center">{{ item.company_name }}</CCol>
    <CCol xs="1" class="text-center ps-0">{{
      formatTimestamp(item.created)
    }}</CCol>
    <CCol xs="3" class="text-center">{{ item.title }}</CCol>
    <CCol xs="1" class="text-center">{{ formatTimestamp(item.updated) }}</CCol>
    <CCol xs="2" class="text-center">
      <div
        class="state"
        :style="
          +item.finish_rate === 100
            ? 'background: #74D39C;'
            : 'background: #FE988E;'
        "
      >
        <p style="margin-right: 5px; margin-bottom: 0">
          {{ item.done_count }}/{{
            item.done_count + item.undone_count + item.unknown_count
          }}
        </p>
        {{ item.finish_rate }}%
      </div></CCol
    >
    <CCol xs="1" class="d-flex align-items-center justify-content-center">
      <button
        v-if="isButtonShow('questionnaire/fill-in-info')"
        :disabled="item.done_count + item.undone_count + item.unknown_count < 1"
        class="border-0 btn btn-primary result text-nowrap"
        @click="toResult(item.id)"
      >
        {{ iframeId === item.id ? '收合結果' : '展開結果' }}
      </button>
    </CCol>
    <CCol xs="1" class="d-flex align-items-center justify-content-center">
      <button
        v-if="isButtonShow('questionnaire/download')"
        class="border-0 btn btn-primary result"
        @click="download(item.questionnaire_id, item.user_id)"
      >
        下載
      </button>
    </CCol>
    <CCol xs="1" class="d-flex align-items-center justify-content-center">
      <CButton
        v-if="isButtonShow('questionnaire/delete-fill-in-list')"
        color="light"
        class="list-btn text-nowrap"
        @click="deleteFilledResult(item.id)"
      >
        刪除
        <img src="@/assets/icons/delete.svg" alt="" />
      </CButton>
    </CCol>
    <div
      v-if="iframeId === item.id"
      class="iframe-wrapper"
      :class="{ 'iframe-wrapper-active': iframeId === item.id }"
    >
      <div class="iframe-loading">
        <div class="loader" />
      </div>
      <iframe
        id="iframe"
        width="100%"
        height="100%"
        :src="iframeHref"
        title="W3Schools Free Online Web Tutorials"
      ></iframe>
    </div>
  </CRow>
  <div class="d-flex align-items-center justify-content-center py-4">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pagination.totalCount"
      :page-size="pagination.pageSize"
      @current-change="changePage"
    />
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import MsgBox from '@/components/MsgBox.vue'
import { ref } from '@vue/reactivity'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { formatDate } from '@/utils/format-date.js'
import router from '@/router'
import { computed, nextTick } from '@vue/runtime-core'
import MessageBox from '@/plugins/MessageBox'
import { useStore } from 'vuex'
export default {
  components: {
    MsgBox,
  },
  setup() {
    const { getFillInList, downloadQuestionnaire, deleteResult } =
      useQuestionnaire()
    const options = ref(['時間： 全部', 2, 3, 4])
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const enterpriseList = ref([])
    const filterValue = ref('')
    const filterValue2 = ref('')
    const filterValue3 = ref('')
    const pagination = ref({})
    const currentPage = ref(1)
    const iframeId = ref(null)
    const iframeHref = ref(null)
    const store = useStore()
    const getList = async () => {
      const res = await getFillInList()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
    }
    getList()
    const isButtonShow = (key) => {
      if (store.state.userInfo.auth_data === true) {
        return true
      } else {
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const changePage = async (page) => {
      currentPage.value = page
      const res = await getFillInList({ page: currentPage.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
      document.scrollingElement.scrollTop = 0
    }
    const filteredEnterpriseList = computed(() => {
      return enterpriseList.value
        ?.filter((e) => {
          return filterValue.value.length
            ? e.company_name?.includes(filterValue.value) ||
                e.questionnaire_title?.includes(filterValue.value)
            : true
        })
        // .sort((x, y) => {
        //   return y.updated - x.updated
        // })
    })
    const download = async (queId, id) => {
      const res = await downloadQuestionnaire({
        questionnaire_id: String(queId),
        user_id: String(id),
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        // download(res.ret.download)
        window.open(res.ret.download, '_blank')
      }
    }
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }
    const toResult = async (id) => {
      if (iframeId.value === id) {
        iframeId.value = null
        return
      }
      iframeId.value = id
      const routeData = router.resolve({
        path: `/result/${id}`,
      })
      // window.open(routeData.href)
      iframeHref.value = routeData.href
      nextTick(() => {
        const el = document.getElementById('iframe')
        console.log(el)
        el.contentWindow.postMessage({ message: 'message' })
      })
      // window.open(routeData.href, '_blank')
    }
    const toAnalyze = (id) => {
      const routeData = router.resolve({
        path: `/analyze/${id}`,
      })
      window.open(routeData.href, '_blank')
    }

    const deleteFilledResult = async (id) => {
      MessageBox({
        message: '刪除後無法復原，您確定要刪除此問卷結果？',
        onConfirm: async () => {
          const res = await deleteResult({ id })
          if (res.error) {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          } else {
            await getList()
          }
        },
      })
    }

    return {
      options,
      enterpriseList,
      getList,
      errorCode,
      errorMsg,
      showMsgBox,
      formatTimestamp,
      toResult,
      download,
      toAnalyze,
      filterValue,
      filterValue2,
      filterValue3,
      filteredEnterpriseList,
      deleteResult,
      deleteFilledResult,
      pagination,
      currentPage,
      changePage,
      iframeId,
      iframeHref,
      isButtonShow,
    }
  },
}
</script>
<style lang="scss" scoped>
div {
  cursor: default;
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

.filter {
  margin-top: 50px;
}

.search {
  right: 16px;
}
.list {
  font-size: 14px;
  min-height: 48px;
  border-radius: 20px;
}

.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 10px;
  }
}
.result {
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d1e5ef;
  color: #187baf;
  border-radius: 4px;
}
.list-title {
  font-size: 14px;
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 90px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.iframe-wrapper {
  position: relative;
  height: 0px;
  width: 100%;
  visibility: hidden;
  transition: all 0.3s linear;
  margin-top: 30px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px;
}
.iframe-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -1;
  .loader {
    width: 80px;
    height: 80px;
    border-radius: 999px;
    border-style: solid;
    border-width: 10px;
    border-color: #187baf #187baf #187baf transparent;
    animation: loading 0.8s linear infinite;
  }
}
.iframe-wrapper-active {
  height: 100vh;
  width: 100%;
  visibility: visible;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
